module.exports = __webpack_public_path__ + "ab68ecac5c0ebf87a2fdadad011642aa.png";